import { isAfter } from 'date-fns';

/**
 * Transform API DOCUMENTS into to dowload tickets for P2P.
 * Not based on fulfillments, but 1 document per passenger on the booking.
 */
export function transformTicketP2P(
    passengerRef: string,
    documentItems: ApiSchema['Document'][],
    admissions: ApiSchema['Admission'][],
    reservations: ApiSchema['Reservation'][],
    apiTrips: ApiSchema['Trip'][],
    apiBooking: ApiSchema['Booking'],
): TicketP2P {
    const passengers = apiBooking.passengers
        .filter(p => passengerRef === p.id)
        .map(p => transformPassenger(p));

    const id = passengerRef;
    const type = 'P2P';
    const summaryLine1 = passengers.map(p => `${p.firstName} ${p.lastName}`).join(', ');
    const summaryLine2 = passengers.map(p => `*${formatMonthMediumYear(p.dateOfBirth)}`).join(', ');
    const detailLine1 = '';
    const detailLine2 = '';

    // The downloadable documents (activity vouchers / Wallet passes)
    const documents = documentItems?.map(d => ({
        download: d.downloadLink ?? '',
        format: d.format ?? '',
        type: d.type,
    })) ?? [];

    // Return matching trips, so we can display trip details on the ticket download (Origin --> Destination)
    const trips = apiTrips.map(t => transformBookedTrip(t)).filter(Boolean) as Trip[];
    // If already in the past
    const isExpired = admissions.every(a => isAfter(zurichDate(), zurichDate(a.validUntil)))
        && reservations.every(r => isAfter(zurichDate(), zurichDate(r.validUntil)));
        // If already refunded
    const isRefunded = admissions.every(a => a.status === 'REFUNDED')
        && reservations.every(a => a.status === 'REFUNDED');
    const isDownloadable
        = documents.length > 0
            && !isExpired
            && !isRefunded;

    return {
        id,
        type,
        summaryLine1,
        summaryLine2,
        detailLine1,
        detailLine2,
        documents,
        trips,
        isExpired,
        isRefunded,
        isDownloadable,
    };
}
